import React from 'react';
import './alarm.css';
import '../../App.css';
import AlarmList from './alarmList';





function Alarm() {



  return (
    <div className='main-Public-wrap'>

      <div className='Measurement-wrap'>

        <AlarmList/>

      </div>


  

      
    </div>
  );  
}

export default Alarm;









